<template>
  <vxe-grid ref="table" v-bind="vxeOption"> </vxe-grid>
</template>

<script>
import { mapMutations } from "vuex";
import {
  tableOptionColums,
  tableOption,
  createRateSlot,
} from "@/views/report/indicators/option/tableOption.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      vxeOption: {},
    };
  },
  computed: {
    ...mapGetters(["tableData"]),
  },
  watch: {
    tableData: {
      deep: true,
      handler(newVal, oldVal) {
        this.getTableData();
      },
    },
  },
  methods: {
    ...mapMutations(["SET_ACTIVE_NAME", "SET_ORDER_RESULT_LIST_QUERY_PARAMS","SET_SHOW_LIST"]),
    // 点击事件
    handleCellClick({ row, rowIndex, column }) {
      console.log(row, rowIndex, column);
      var serviceTypeName = column.params ? column.params.serviceTypeName : []
      var flag = column.params ? column.params.flag : []
      var params = {
        startDate: row.startDate,
        endDate: row.endDate,
        userCode: row.userCode,
        userType: row.userType,
        serviceTypeName: serviceTypeName,
        flag: flag
      }
      this.SET_ORDER_RESULT_LIST_QUERY_PARAMS(params);
      this.SET_ACTIVE_NAME("second");
      this.SET_SHOW_LIST(true);
    },
    getTableData() {
      var _tableData = Object.assign([], this.tableData);
      // 将 list 转换为以 rateFor 为 key 的对象
      this.$refs.table.reloadData(_tableData.records);
      for (let key in this.vxeOption.columns) {
        if (this.vxeOption.columns.hasOwnProperty(key)) {
          if (this.vxeOption.columns[key]["slots"]) {
            var h = this.$createElement;
            this.vxeOption.columns[key]["slots"].default = createRateSlot(
              _tableData,
              h,
              this.handleCellClick
            );
          }
        }
      }
    },
  },
  created() {
    Object.assign(this.vxeOption, tableOption);
    this.vxeOption.columns = tableOptionColums;
  },
  mounted() {
    // this.getTableData();
  },
};
</script>

<style lang="scss"></style>
